"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonPinkLg = exports.ButtonPrimSm = exports.ButtonPink = exports.ButtonPrim = exports.ButtonPinkLgN = void 0;
var DefaultPropsHoC_1 = __importDefault(require("components/Generic/DefaultPropsHoC"));
var ButtonBase_1 = __importDefault(require("./ButtonBase"));
var ButtonPrim = (0, DefaultPropsHoC_1.default)(ButtonBase_1.default, { color: 'primary' });
exports.ButtonPrim = ButtonPrim;
var ButtonPink = (0, DefaultPropsHoC_1.default)(ButtonBase_1.default, { color: 'pink' });
exports.ButtonPink = ButtonPink;
var ButtonPrimSm = (0, DefaultPropsHoC_1.default)(ButtonBase_1.default, { color: 'primary', size: 'sm' });
exports.ButtonPrimSm = ButtonPrimSm;
var ButtonPinkLg = (0, DefaultPropsHoC_1.default)(ButtonBase_1.default, { color: 'pink', outline: true, size: 'lg' });
exports.ButtonPinkLg = ButtonPinkLg;
exports.ButtonPinkLgN = (0, DefaultPropsHoC_1.default)(ButtonBase_1.default, { color: 'pink', size: 'lg' });
